/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Address } from './Address';
import { AwardWin } from './AwardWin';
import { Geopoint } from './Geopoint';
import { MemberOrgAccess } from './MemberOrgAccess';
import { Prefs } from './Prefs';
import { Social } from './Social';
import { Tag } from './Tag';
import { TagData } from './TagData';
import { EligibleItemMapping } from './EligibleItem';
import { ChapterPosition } from './ChapterPosition';
export interface Member {
  /**
   * name of member
   */
  name?: string;

  /**
   * globally unique id
   */
  id?: string;

  /**
   * top-level type of member
   */
  type?: Member.Type;

  /**
   * whether the member's profile is publicly available
   */
  visibility?: Member.Visibility;

  /**
   * longer member description
   */
  description?: string;

  /**
   * expanded list of tags, denormalized from entity
   */
  tags?: Array<Tag>;

  /**
   * created by user id
   */
  createId?: string;

  /**
   * expiration date of current paid plan
   */
  expireDate?: string;

  wikiExpireDate?: string;

  certificationExpireDate?: string;
  /**
   * password of user (encrypted)
   */
  passwordCrypt?: string;

  /**
   * public phone number in E.164 format
   */
  publicPhone?: string;

  /**
   * home phone number in E.164 format
   */
  homePhone?: string;

  /**
   * public address of member
   */
  publicAddress?: Address;

  /**
   * home address for users
   */
  homeAddress?: Address;

  /**
   * date of joining NKBA
   */
  joinDate?: string;

  /**
   * year of founding
   */
  foundedYear?: string;

  /**
   * created timestamp
   */
  createAt?: string;

  /**
   * last updated timestamp
   */
  updateAt?: string;

  /**
   * last login timestamp
   */
  loginAt?: string;

  /**
   * stripe customer id
   */
  stripeCustomerId?: string;

  /**
   * chapter id
   */
  chapterId?: string;

  /**
   * id of chapter if assigned to be admin for other chapter
   */
  chapterAdmin?: string;

  /**
   * unique slug of member (including base org slug if this is a sub-org member)
   */
  slug?: string;

  /**
   * member number
   */
  number?: number;

  /**
   * image path
   */
  imagePath?: string;

  /**
   * whether the old dues type, or the new dues schedule is in use
   */
  duesType?: Member.DuesType;

  /**
   * eligible items assigned to member
   */
  eligibleOrderProducts?: EligibleItemMapping[];
  vouchers?: EligibleItemMapping[];
  /**
   * admin access level
   */
  adminAccess?: Member.AdminAccess;

  /**
   * chapter role
   */
  chapterRole?: Member.ChapterRole;

  /**
   * company name
   */
  companyName?: string;

  /**
   * company website
   */
  website?: string;

  /**
   * job title
   */
  jobTitle?: string;

  /**
   * path to cover image
   */
  coverImagePath?: string;

  /**
   * public email address
   */
  publicEmail?: string;

  /**
   * number of employees
   */
  employeeRange?: Member.EmployeeRange;

  /**
   * short member description (max 255 characters)
   */
  bio?: string;

  /**
   * social media info
   */
  social?: Social;

  /**
   * last date that a renewal notification was sent
   */
  renewNoticeDate?: string;

  /**
   * number of branches paid for on current plan
   */
  paidBranchCount?: number;

  /**
   * actual current branch count
   */
  branchCount?: number;

  /**
   * count of independent branches
   */
  indBranchCount?: number;

  /**
   * last updated by user id
   */
  updateId?: string;

  /**
   * status
   */
  status?: Member.Status;

  /**
   * member's long/lat of work address, in GeoJSON format
   */
  geo?: Geopoint;

  /**
   * billing address
   */
  billingAddress?: Address;

  /**
   * shipping address
   */
  shippingAddress?: Address;

  /**
   * set of tag ids for this member, denormalized from entity
   */
  tagIds?: Array<string>;

  /**
   * list of awards won
   */
  awards?: Array<AwardWin>;

  /**
   * list of member orgs with permission levels
   */
  orgs?: Array<MemberOrgAccess>;

  /**
   * internal email address
   */
  email?: string;

  /**
   * internal secondary email address
   */
  secondaryEmail?: string;

  /**
   * org id that this member is part of, if the member represents an org branch
   */
  parentOrgId?: string;

  /**
   * revenue level
   */
  revenueRange?: string;

  /**
   * work address of member
   */
  workAddress?: Address;

  /**
   * set of internal tag ids for this member, denormalized from entity
   */
  internalTagIds?: Array<string>;

  /**
   * member type
   */
  memberType?: Member.MemberType;

  /**
   * work phone number in E.164 format
   */
  workPhone?: string;

  /**
   * mobile phone number in E.164 format
   */
  mobilePhone?: string;

  /**
   * whether to autorenew the current plan on account credit card
   */
  renewType?: Member.RenewType;

  /**
   * Segment for orgs
   */
  segment?: string;
  // Member.Segment;

  /**
   * Functional role for member
   */
  functionalRole?: string;

  /**
   * Organization level for member
   */
  organizationLevel?: string;

  /**
   * first name of user member
   */
  firstName?: string;

  /**
   * last name of user member
   */
  lastName?: string;

  /**
   * preferences that can be set by the user
   */
  prefs?: Prefs;

  /**
   * assigned tags - public tags that have been assigned by the NKBA but cannot be set directly by the member
   */
  assignedTags?: Array<TagData>;

  /**
   * map of contact types to member ids (for orgs only)
   */
  contacts?: { [key: string]: string };

  /**
   * NKBA founding school - for memberType of SCHOOL only
   */
  foundingSchool?: boolean;

  /**
   * list of programs offered by this school - for memberType of SCHOOL only
   */
  programsOffered?: Array<string>;

  /**
   * how the programs are offered - for memberType of SCHOOL only
   */
  programType?: Member.ProgramType;

  /**
   * web address for school programs - for memberType of SCHOOL only
   */
  programsWebAddress?: string;

  /**
   * degrees offered by school - for memberType of SCHOOL only
   */
  degreesOffered?: Array<Member.DegreesOffered>;

  /**
   * if the school has been approved by the AKBD testing center - for memberType of SCHOOL only
   */
  akbdApproved?: boolean;

  /**
   * client-specific custom vars
   */
  vars?: any;

  /**
   * chapter Position
   */
  chapterPosition?: ChapterPosition;

  jobsFeatured?: boolean;
}

export namespace Member {
  export enum Type {
    ORG = <any>'ORG',
    USER = <any>'USER',
  }
  export enum Visibility {
    PUBLIC = <any>'PUBLIC',
    PRIVATE = <any>'PRIVATE',
  }
  export enum DuesType {
    OLD = <any>'DUES_OLD',
    _2017 = <any>'DUES_2017',
  }
  export enum AdminAccess {
    NONE = <any>'NONE',
    PARTNER = <any>'PARTNER',
    STAFF = <any>'STAFF',
    MEMBERSHIP = <any>'MEMBERSHIP',
    MEMBERSHIP_PLUS = <any>'MEMBERSHIP_PLUS',
    PROFESSIONAL = <any>'PROFESSIONAL',
    CHAPTERS = <any>'CHAPTERS',
    ACCOUNTING = <any>'ACCOUNTING',
    ADMIN = <any>'ADMIN',
    SUPERUSER = <any>'SUPERUSER',
    CHAPTERSADMIN = <any>'CHAPTERSADMIN',
  }
  export enum ChapterRole {
    NONE = <any>'NONE',
    MEMBER = <any>'MEMBER',
    OFFICER = <any>'OFFICER',
  }
  export enum EmployeeRange {
    MAX_5 = <any>'MAX_5',
    MAX_10 = <any>'MAX_10',
    MAX_25 = <any>'MAX_25',
    MAX_100 = <any>'MAX_100',
    MAX_250 = <any>'MAX_250',
    OVER_250 = <any>'OVER_250',
  }
  export enum Status {
    ACTIVE = <any>'ACTIVE',
    INACTIVE = <any>'INACTIVE',
    EXPIRED = <any>'EXPIRED',
  }
  export enum MemberType {
    NONE = <any>'NONE',
    PROSPECT = <any>'PROSPECT',
    MEMB = <any>'MEMB',
    STUDENT = <any>'STUDENT',
    SCHOOL = <any>'SCHOOL',
    IM = <any>'IM',
    EM = <any>'EM',
    IP = <any>'IP',
    RG = <any>'RG',
    HON = <any>'HON',
    IBRANCH = <any>'IBRANCH',
    BRANCH = <any>'BRANCH',
    RETIRED = <any>'RETIRED',
  }
  export enum RenewType {
    AUTO = <any>'AUTO',
    BILL = <any>'BILL',
    MANUAL = <any>'MANUAL',
  }
  export enum ProgramType {
    IN_PERSON = <any>'IN_PERSON',
    ONLINE = <any>'ONLINE',
    IN_PERSON_ONLINE = <any>'IN_PERSON_ONLINE',
  }
  export enum Segment {
    BUILDING = <any>'BUILDING',
    COLLEGE = <any>'COLLEGE',
    CABINET = <any>'CABINET',
    DEALER = <any>'DEALER',
    DESIGN = <any>'DESIGN',
    IP = <any>'IP',
    MANUFACTURING = <any>'MANUFACTURING',
    RETAIL = <any>'RETAIL',
    SKILLED = <any>'SKILLED',
    WHOLESALE = <any>'WHOLESALE',
    OTHER = <any>'OTHER',
  }
  export enum DegreesOffered {
    DIPLOMA = <any>'DIPLOMA',
    CERTFICATE = <any>'CERTIFICATE',
    BACHELOR = <any>'BACHELOR',
    MASTER = <any>'MASTER',
    DOCTOR = <any>'DOCTOR',
  }
}



// WEBPACK FOOTER //
// ./src/common/api/models/Member.ts